module.exports = __webpack_public_path__ + "024c48ce519b8f2ab6979a891b42cb14.pdf";